import { NoteEditorView } from '../view/NoteEditorView';
import { templateNoteEditor } from '../view/template';
import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { NoteEditorWebComponent } from '../index';
import _, { trim } from 'lodash';
import { EditCardEvents, NoteDisplayMode } from '../types';

export class NoteEditorController extends BaseWebComponentController {
  public component: NoteEditorWebComponent;
  public view: NoteEditorView;
  public viewConstructor: typeof NoteEditorView;

  constructor(component: NoteEditorWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: NoteEditorView,
      viewTemplate: templateNoteEditor,
    });
  }

  async getDataForView(): Promise<any> {
    return {
      note: this.component.note,
    };
  }

  public computeEventListeners() {
    return [
      {
        element: this.view.dom.$cancelButton,
        event: 'click',
        callback: this.closeEditNoteComponent,
      },
      {
        element: this.view.dom.$saveButton,
        event: 'click',
        callback: this.saveOrEditNote,
      },
      {
        element: this.view.dom.$discardCancelButton,
        event: 'click',
        callback: this.discardCancelHandler,
      },
      {
        element: this.view.dom.$discardButton,
        event: 'click',
        callback: this.discardHandler,
      },
      {
        element: this.view.dom.$deleteButton,
        event: 'click',
        callback: this.deleteHandler,
      },
      {
        element: this.view.dom.$cancelButtonFromDeletePanel,
        event: 'click',
        callback: this.cancelDeletePanelHandler,
      },
      {
        element: this.view.dom.$wrapper,
        event: 'change',
        callback: this.setButtonActive,
      },
    ];
  }

  private setButtonActive(Event) {
    const value = trim(Event.target.value);
    this.view.dom.$saveButton.disabled = value.length === 0;
  }

  private discardHandler() {
    this.dispatchCloseWindowEvent();
    this.component.remove();
  }

  private dispatchCloseWindowEvent() {
    this.component.dispatchEvent(
      new CustomEvent(EditCardEvents.CLOSE_WINDOW, {
        bubbles: true,
        cancelable: true,
        composed: false,
      })
    );
  }

  private discardCancelHandler() {
    this.component.displayMode = NoteDisplayMode.EDIT;
  }

  private cancelDeletePanelHandler() {
    this.dispatchCloseWindowEvent();
    this.component.remove();
  }

  private closeEditNoteComponent() {
    if (this.view.dom.$noteEditorTextarea.value === '') {
      this.dispatchCloseWindowEvent();
      this.component.remove();
      return;
    }
    this.component.displayMode = NoteDisplayMode.DISCARD;
  }

  private saveOrEditNote() {
    if (!_.isEmpty(this.component.note)) {
      this.component.dispatchEvent(
        new CustomEvent(EditCardEvents.EDIT_NOTE, {
          detail: {
            noteRequest: {
              text: this.view.dom.$noteEditorTextarea.value,
              _id: this.component.note._id,
            },
          },
          bubbles: true,
          cancelable: true,
          composed: false,
        })
      );
    } else {
      this.component.dispatchEvent(
        new CustomEvent(EditCardEvents.CREATE_NOTE, {
          detail: {
            noteRequest: {
              text: this.view.dom.$noteEditorTextarea.value,
            },
          },
          bubbles: true,
          cancelable: true,
          composed: false,
        })
      );
    }
  }

  private deleteHandler() {
    this.component.dispatchEvent(
      new CustomEvent(EditCardEvents.DELETE_NOTE, {
        detail: {
          noteRequest: {
            _id: this.component.note._id,
          },
        },
        bubbles: true,
        cancelable: true,
        composed: false,
      })
    );
  }
}
